module.exports = __webpack_public_path__ + "img/qy (25).4af60121.png";